/**
 * https://stackoverflow.com/a/1099670/2614364
 * @param  {[type]} qs [description]
 * @return {[type]}    [description]
 */
/*eslint-disable */
export function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

/**
 * Check if URL is valid https://stackoverflow.com/a/30229098/2614364
 * 
 * @param  {String}  str url
 * @return {Boolean}     url validity
 */
export function isValidUrl(str) {
    return /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!-/]))?/.test(str);
}

export function isNumeric(value: any): boolean {
    return !isNaN(value - parseFloat(value));
}


// WEBPACK FOOTER //
// ./src/utils/Utils.js